var DropdownItem = /** @class */ (function () {
    function DropdownItem(id, name) {
        this.id = id;
        this.name = name;
    }
    return DropdownItem;
}());
export { DropdownItem };
